import React from 'react'
import { observer } from 'mobx-react'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import Button from 'ui/buttons/Button'
import { Translation } from '@morningtrain/react-translations'
import * as Auth from '@morningtrain/react-auth'
import { ExecuteOperationForModelOnPipe, ExecuteOperationOnPipe } from '@morningtrain/react-resources'

function SubmitForApproval (props) {
  return (
    <Auth.CanUseModel permission='api.shifts.schedule.submit_for_approval'>
      <Pipeline>
        <TriggerPipelineOnClick>
          <Button>
            <Translation name='generic.submit_for_approval' defaultValue='Submit for approval' />
          </Button>
        </TriggerPipelineOnClick>
        <ExecuteOperationForModelOnPipe operationName='submit_for_approval' />
        <ExecuteOperationOnPipe resourceName='shifts.schedule' operationName='fetch' />
        <ExecuteOperationOnPipe resourceName='shifts.schedule' operationName='read' />
        <ExecuteOperationOnPipe resourceName='shifts.schedule_slot' operationName='grouped_by_day' />
      </Pipeline>
    </Auth.CanUseModel>
  )
}

export default observer(SubmitForApproval)
